import ReservationRequest from "../../../views/web/pages/ReservationRequest";

export const webUrls = {
    ping: '/ping',
    ui: '/general/ui',
    login: {
        check: '/authentication/login',
        requestOtp: '/authentication/otp',
        verify: '/authentication/verify'
    },
    contact: '/general/contact',
    ReservationRequest: '/general/reservation-request',
    PaymentGateway: "/general/direct-payment/payment-gateways",
    finalPaymentGateway: "/general/direct-payment",
    optionalPaymentResult: (code) => `/general/optional-payment-result/${code}`,
    articles: {
        list: '/general/articles',
        item: (articleSlug) => `/general/articles/${articleSlug}`,
        categories: '/general/articles/categories'
    },
    commercialPartners: {
        list: '/general/commercial-partners',
        item: (commercialpartnerSlug) => `/general/commercial-partners/${commercialpartnerSlug}`,
        categories: '/general/commercial-partners/categories'
    },
    services: {
        list: '/general/services',
        item: (serviceSlug) => `/general/services/${serviceSlug}`,
        categories: '/general/services/categories'
    },
    catalogs: {
        list: '/general/catalogs',
        item: (catalogSlug) => `/general/catalogs/${catalogSlug}`,
        categories: '/general/catalogs/categories'
    },
    products: {
        list: '/general/products',
        tagsList: '/general/tag/',
        favorite: '/customer/favorite'
    },
    product: {
        data: (productSlug) => `/general/product/${productSlug}`,
        comment: {
            data: '/general/comments',
            like: (commentId) => `/general/comments/${commentId}/like`
        },
        notifyAvailability: '/customer/notify-availability'
    },
    customDoor: '/general/custom-door',
    cart: '/customer/cart',
    useCredit: '/customer/cart/customer-club/use-credit',
    shipping: {
        delivery: '/customer/set-delivery',
        address: '/customer/set-address',
    },
    payment: {
        gateway: '/customer/set-gateway',
        paymentMethod: '/customer/set-payment',
        coupon: '/customer/set-coupon',
        final: '/customer/payment',
        result: (orderCode) => `/general/payment-result/${orderCode}`,
        wallet: "/customer/cart/wallet/use-balance"
    },
    address: {
        data: '/customer/address',
        item: (addressId) => `/customer/address/${addressId}`
    },
    generalLocation: '/general/location',
    links: '/general/links',
    captcha: '/general/captcha',
    quickSearch: '/general/search',
    partiesToTheContract: "/general/customer-brands",
    gallery: {
        list: "/general/galleries"
    },
    filter: {
        list: "/general/advanced-search"
    },
}
